module.exports = __webpack_public_path__ + "img/fusibles_y_portafusibles.bbb42478.gif";